export const phoneRegex = new RegExp(
  /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/,
);

export const validateEmail = (email: string) => {
  return String(email)
    .toLowerCase()
    .match(/^\S+@\S+\.\S+$/);
};

export const validatePhone = (email: string) => {
  return String(email).toLowerCase().match(phoneRegex);
};

export const validateNumeric = (email: string) => {
  return String(email).toLowerCase().match(/^\d+$/);
};

export enum HttpMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
}

export enum Environment {
  DEVELOPMENT = "development",
  STAGING = "staging",
  PRODUCTION = "production",
}

export const FIGHT_OFFER_REALTIME_MESSAGE_PREFIX = "__fight_offer_event__:";

export function createFightOfferRealtimeMessageContent(eventType: string) {
  return `${FIGHT_OFFER_REALTIME_MESSAGE_PREFIX}${eventType}`;
}

export function isFightOfferRealtimeMessage(content?: string | null) {
  return content?.startsWith(FIGHT_OFFER_REALTIME_MESSAGE_PREFIX) ?? false;
}

export const REGISTRATION_REJECTION_CODE_CATEGORY_REMOVED = "CATEGORY_REMOVED";
export const REGISTRATION_REJECTION_CODE_EVENT_CANCELED = "EVENT_CANCELED";
